export default "/images/incoming-emails-active-dark.svg?4c34418c35f85aedb45d2961dfd8cf5c";